
import React from "react";
import { Button } from "../../ui/button";
import { SendHorizonal } from "lucide-react";
import { Textarea } from "../../ui/textarea";
import { useChatInput } from "./hooks/useChatInput";

interface ChatInputProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  handleSendMessage: () => void;
  isDisabled: boolean;
}

export const ChatInput = ({
  inputValue,
  setInputValue,
  handleSendMessage,
  isDisabled,
}: ChatInputProps) => {
  const { inputRef, handleKeyDown } = useChatInput({
    inputValue,
    setInputValue,
    handleSendMessage,
    isDisabled,
  });

  return (
    <div className="flex gap-2">
      <Textarea
        ref={inputRef}
        placeholder="Type your message here..."
        className="min-h-[40px] resize-none bg-background dark:bg-gray-700 dark:text-white"
        value={inputValue}
        disabled={isDisabled}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <Button
        size="icon"
        type="submit"
        disabled={!inputValue.trim() || isDisabled}
        onClick={handleSendMessage}
        className="bg-primary hover:bg-primary/90 text-white"
      >
        <SendHorizonal className="h-5 w-5" />
      </Button>
    </div>
  );
};
